/**
 * Build-time configuration. The Quasar app hard-coded these in boot/axios.js,
 * api/discord.js and components/Auth.vue; they are now environment variables so
 * the same source tree can build against staging and against production, and so
 * the desktop/mobile shells can point somewhere else entirely.
 */

/** Injected by vite.config.ts — which shell this bundle was built for. */
declare const __JLM_TARGET__: 'web' | 'capacitor' | 'electron'

function required(value: string | undefined, name: string, fallback: string): string {
  if (value && value.length > 0) return value
  if (import.meta.env.DEV) {
    console.warn(`[env] ${name} is not set; falling back to "${fallback}"`)
  }
  return fallback
}

export const env = {
  buildTarget: typeof __JLM_TARGET__ === 'undefined' ? 'web' : __JLM_TARGET__,

  apiBaseUrl: required(
    import.meta.env.VITE_API_BASE_URL,
    'VITE_API_BASE_URL',
    'https://api.justloot.me',
  ),

  discordClientId: required(
    import.meta.env.VITE_DISCORD_CLIENT_ID,
    'VITE_DISCORD_CLIENT_ID',
    '847752876013256724',
  ),

  oauthRedirectOrigin: required(
    import.meta.env.VITE_OAUTH_REDIRECT_ORIGIN,
    'VITE_OAUTH_REDIRECT_ORIGIN',
    'https://justloot.me',
  ),

  nativeDeepLinkScheme: import.meta.env.VITE_NATIVE_DEEPLINK_SCHEME ?? 'jlm',
} as const

export type BuildTarget = typeof env.buildTarget
